// import React, { useState } from "react";
// import "./SalesManager.css";
// import ManagerDashboard from "./SalesManager/ManagerDashboard.jsx";
// import ManagerSourcing from "./SalesManager/ManagerSourcing.jsx";
// import ManagerEnquiry from "./SalesManager/ManagerEnquiry.jsx";
// import ManagerApproval from "./SalesManager/ManagerApproval.jsx";
// import ManagerClients from "./SalesManager/ManagerClients.jsx";
// import PurchaseOrders from "./SalesManager/PurchaseOrders.jsx";
// import ManagerAssigned from "./SalesManager/ManagerAssigned.jsx";
// import ManagerQuotation from "./SalesManager/ManagerQuotation.jsx";



// const DummySection = ({ title }) => {
//   return (
//     <div className="dummy-box">
//       <h2>{title}</h2>
//       <p>This is a dummy section for <strong>{title}</strong>.</p>
//       <span>Content will be added later 🚧</span>
//     </div>
//   );
// };

// const SalesManager = () => {
//   // Define tabs - Sales Manager specific
//   const tabs = [
//     { id: 1, name: "Dashboard", component: () => <ManagerDashboard /> },
//     // { id: 2, name: "Sourcing", component: () => <ManagerSourcing /> },
//     { id: 3, name: "Enquiries", component: () => <ManagerEnquiry /> },
//     { id: 4, name: "Approvals", component: () => <ManagerApproval /> },
//     { id: 5, name: "Quotation", component: () => <ManagerQuotation /> },
//     { id: 6, name: "Assigned", component: () => <ManagerAssigned /> },
//     // { id: 7, name: "Clients", component: () => <ManagerClients /> },
//     { id: 8, name: "Purchase Orders", component: () => <PurchaseOrders /> },
//     // Add more tabs as needed
//     // { id: 6, name: "Quotations", component: () => <SalseQuotation /> },
//     // { id: 7, name: "Pipeline", component: () => <SalesPipeline /> },
//     // { id: 8, name: "Team", component: () => <SalesTeam /> },
//     // { id: 9, name: "Reports", component: () => <Mangerclintoverview /> },
//   ];

//   const [activeTab, setActiveTab] = useState(tabs[0].id);

//   const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

//   return (
//     <div className="sales-manager-container">
//       {/* Tabs */}
//       <div className="sm-tabs-wrapper">
//         <div className="sm-tabs-scroll">
//           <div className="sm-tabs-row">
//             {tabs.map((tab) => (
//               <button
//                 key={tab.id}
//                 className={`sm-tab-btn ${activeTab === tab.id ? "sm-tab-active" : ""
//                   }`}
//                 onClick={() => setActiveTab(tab.id)}
//               >
//                 {tab.name}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Active Component */}
//       <div className="sm-tab-content">
//         {ActiveComponent && <ActiveComponent />}
//       </div>
//     </div>
//   );
// };

// export default SalesManager;



import React, { useState,useEffect } from "react";
import "./SalesManager.css";
import ManagerDashboard from "./SalesManager/ManagerDashboard.jsx";
import ManagerSourcing from "./SalesManager/ManagerSourcing.jsx";
import ManagerEnquiry from "./SalesManager/ManagerEnquiry.jsx";
import ManagerApproval from "./SalesManager/ManagerApproval.jsx";
import ManagerClients from "./SalesManager/ManagerClients.jsx";
import PurchaseOrders from "./SalesManager/PurchaseOrders.jsx";
import ManagerAssigned from "./SalesManager/ManagerAssigned.jsx";
import ManagerQuotation from "./SalesManager/ManagerQuotation.jsx";

const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

const SalesManager = () => {
  // Define tabs - Sales Manager specific
  const tabs = [
    { id: 1, name: "Dashboard", component: () => <ManagerDashboard /> },
    // { id: 2, name: "Sourcing", component: () => <ManagerSourcing /> },
    { id: 3, name: "Enquiries", component: () => <ManagerEnquiry /> },
    { id: 4, name: "Approvals", component: () => <ManagerApproval /> },
    { id: 5, name: "Quotation", component: () => <ManagerQuotation /> },
    { id: 6, name: "Assigned", component: () => <ManagerAssigned /> },
    // { id: 7, name: "Clients", component: () => <ManagerClients /> },
    { id: 8, name: "Purchase Orders", component: () => <PurchaseOrders /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  // Function to switch tabs - this will be passed to child components
  useEffect(() => {
         const handleTabChange = (event) => {
             const tabId = event.detail?.tabId;
             
             if (tabId) {
                 // Find tab by name (case insensitive)
                 const tab = tabs.find(t => 
                     t.name.toLowerCase() === tabId.toLowerCase() || 
                     t.id === tabId
                 );
                 
                 if (tab) {
                     setActiveTab(tab.id);
                 } else {
                     console.warn("⚠️ Tab not found:", tabId);
                 }
             }
         };
 
         window.addEventListener('changeTab', handleTabChange);
         return () => window.removeEventListener('changeTab', handleTabChange);
     }, [tabs]);

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="sales-manager-container">
      {/* Tabs */}
      <div className="sm-tabs-wrapper">
        <div className="sm-tabs-scroll">
          <div className="sm-tabs-row">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`sm-tab-btn ${activeTab === tab.id ? "sm-tab-active" : ""
                  }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Active Component - Pass switchTab function as prop */}
      <div className="sm-tab-content">
         {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default SalesManager;